import React, { createContext, useState, useContext, useEffect } from 'react';
import apiService from '../services/api';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadRole = () => {
    apiService.getSmsProfile()
      .then((r) => setUser((u) => (u ? { ...u, role: r.data && r.data.role, userType: r.data && r.data.userType, gebrauchtwagenEnabled: r.data && r.data.gebrauchtwagenEnabled } : u)))
      .catch(() => {});
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    const username = localStorage.getItem('username');

    if (token && username) {
      apiService.setAuthToken(token);
      setUser({ username, token });
      loadRole();
    }

    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const response = await apiService.login(username, password);
      const { token } = response.data;
      
      localStorage.setItem('token', token);
      localStorage.setItem('username', username);
      
      apiService.setAuthToken(token);
      setUser({ username, token });
      loadRole();

      return { success: true };
    } catch (error) {
      const message = error.response?.data?.message || 'Napaka pri prijavi';
      return { success: false, error: message };
    }
  };

  const register = async (username, password) => {
    try {
      const response = await apiService.register(username, password);
      const { token } = response.data;

      localStorage.setItem('token', token);
      localStorage.setItem('username', username);

      apiService.setAuthToken(token);
      setUser({ username, token });

      return { success: true };
    } catch (error) {
      const data = error.response?.data;
      const message = (typeof data === 'string' ? data : data?.message) || 'Napaka pri registraciji';
      return { success: false, error: message };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    setUser(null);
    apiService.setAuthToken(null);
  };

  const value = {
    user,
    login,
    register,
    logout,
    loading
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};